var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCtvHisenseStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.996 1.50378L15.0088 14.4205H10.6674L11.122 8.74326H4.87821L4.34556 14.4943H0.00415039L1.07048 1.50378H4.34556C4.57181 1.50378 5.33884 1.50378 5.33884 2.3512L5.10548 6.04763H11.3543L11.7348 1.50378H15.996Z",
    fill: "#00B3AC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCtvHisenseStore);
export default __webpack_public_path__ + "static/media/ctv_hisense_store.d09d96254046a2a336dcedf4583d9995.svg";
export { ForwardRef as ReactComponent };